import { createSelector } from 'reselect'

export const getAddons = createSelector(
	(state) => state && state.user && state.user.profile && state.user.profile.addons
		&& Array.isArray(state.user.profile.addons.elements) ?
			state.user.profile.addons.elements : [],
  (addons) => addons
)
